export const API_LOADING = 'API_LOADING';
export const API_ERROR = 'API_ERROR';
export const API_VALIDATION_ERROR = 'API_VALIDATION_ERROR';
